import { useMemo } from "react";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/../.sourceflow/jobs.json";

const CATEGORY_IDS = {
  sectors: "3186657c-e89c-4a6f-9157-35eb7fe0b379",
  jobType: "275d8990-bd9e-4f79-a0e2-d81bb734c855",
  workType: "1bfde1ab-62a6-4040-9c0e-5b8c59d4f6d8",
  branches: "33b21b47-15e3-40a2-bc7b-32019e94c7ba",
};

function extractCategory(job, categoryId) {
  return job.categories?.find((cat) => cat.id === categoryId)?.values?.map((v) => v.id) || [];
}

export default function useFilteredJobs({ sectors, jobType, workType, branches } = {}) {
  const rawJobs = useSourceFlowCollection(data.jobs);
  const jobs = useMemo(() => rawJobs, [JSON.stringify(rawJobs)]);

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const sectorMatch =
        !sectors?.length || sectors.some((id) => extractCategory(job, CATEGORY_IDS.sectors).includes(id));
      const jobTypeMatch = !jobType || extractCategory(job, CATEGORY_IDS.jobType).includes(jobType);
      const workTypeMatch = !workType || extractCategory(job, CATEGORY_IDS.workType).includes(workType);
      const branchMatch =
        !branches?.length || branches.some((id) => extractCategory(job, CATEGORY_IDS.branches).includes(id));

      return sectorMatch && jobTypeMatch && workTypeMatch && branchMatch;
    });
  }, [jobs, sectors, jobType, workType, branches]);

  return filteredJobs;
}
